import React from "react";
import { connect } from "react-redux";
import AgenciesTable from "./AgenciesTable";
import AgenciesForm from "./AgenciesForm";
import { mapStateToProps, mapDispatchToProps } from "./Agencies.state";
import { Navigation } from "../..";
import { Pages } from "../../types";
import { Box, ButtonWithLink, Cluster, Title } from "@thecb/components";

const AgenciesControls = () => {
  return (
    <Box padding="0 0 0.5rem">
      <ButtonWithLink
        variant="primary"
        url={`/pos-config/agencies/create`}
        text="Create New Agency"
        extraStyles={`
          border-radius: 19px;
          margin: 0;
        `}
      />
    </Box>
  );
};

const AgenciesPage = () => {
  return (
    <>
      <Title as="h1" weight="bold">
        Agencies
      </Title>
      <Cluster align="center" justify="space-between">
        <Navigation page={Pages.AGENCIES} />
        <AgenciesControls />
      </Cluster>
      <AgenciesTable />
    </>
  );
};

const ConnectedAgenciesForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgenciesForm);

export { AgenciesPage, ConnectedAgenciesForm as AgenciesForm };
